const GUEST_CART_KEY = 'guest_cart';
const GUEST_CART_EXPIRY = 7 * 24 * 60 * 60 * 1000; 

export const getGuestCart = () => {
  try {
    const cartData = localStorage.getItem(GUEST_CART_KEY);
    if (!cartData) return { items: [], expires: null };
    
    const parsed = JSON.parse(cartData);
    
    if (parsed.expires && Date.now() > parsed.expires) {
      localStorage.removeItem(GUEST_CART_KEY);
      return { items: [], expires: null };
    }
    
    return parsed;
  } catch (error) {
    console.error('Error getting guest cart:', error);
    return { items: [], expires: null };
  }
};

export const saveGuestCart = (items) => {
  try {
    const cartData = {
      items: items,
      expires: Date.now() + GUEST_CART_EXPIRY,
      lastUpdated: new Date().toISOString()
    };
    localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cartData));
    return true;
  } catch (error) {
    console.error('Error saving guest cart:', error);
    return false;
  }
};

export const clearGuestCart = () => {
  try {
    localStorage.removeItem(GUEST_CART_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing guest cart:', error);
    return false;
  }
};

export const mergeGuestCartWithUserCart = (guestItems, userItems) => {
  const merged = [...userItems];
  
  guestItems.forEach(guestItem => {
    const existingIndex = merged.findIndex(
      item => item.productId == guestItem.productId && 
              item.variant_id == guestItem.variant_id &&
              (item.product_variant_id || null) == (guestItem.product_variant_id || null) &&
              item.size == guestItem.size
    );
    
    if (existingIndex >= 0) {
      merged[existingIndex].quantity += guestItem.quantity;
    } else {
      merged.push(guestItem);
    }
  });
  
  return merged;
};

export const calculateGuestCartSummary = (items) => {
  const subtotal = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
  
  return {
    subtotal: Number(subtotal.toFixed(2)),
    itemCount,
    total: Number(subtotal.toFixed(2)) 
  };
};